var map = {
	"./blocks/custom/logoSlider/block.js": 86890,
	"./blocks/custom/portfolioSlider/block.js": 77959,
	"./blocks/custom/quoteSlider/block.js": 85555,
	"./blocks/sky/callToActionCharlie/block.js": 189,
	"./blocks/sky/contentBlog/block.js": 78871,
	"./blocks/sky/headerAlfa/block.js": 23717,
	"./blocks/sky/headerBravo/block.js": 42241,
	"./blocks/sky/headerCharlie/block.js": 40223,
	"./blocks/sky/scrollUpAlfa/block.js": 8544,
	"./blocks/sky/sliderAlfa/block.js": 63089,
	"./blocks/sky/sliderBravo/block.js": 67781
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49363;